/**
 * Text normalization for tolerant grading (blanks, transcription,
 * written flashcards). Pure and deterministic.
 */

export interface NormalizeOpts {
  /** Case sensitive (default false). */
  caseSensitive?: boolean;
  /** Keep accents/diacritics (default false: removed). */
  keepDiacritics?: boolean;
  /** Keep punctuation (default false). */
  keepPunctuation?: boolean;
}

const PUNCTUATION = /[.,;:!?¿¡"'`´()[\]{}<>/\\|@#$%^&*_+=~-]/g;

export function normalizeText(input: string, opts: NormalizeOpts = {}): string {
  let s = input.normalize("NFC").trim();
  if (!opts.caseSensitive) {
    s = s.toLowerCase();
  }
  if (!opts.keepDiacritics) {
    // Decomposes and strips combining marks (accented -> plain).
    s = s.normalize("NFD").replaceAll(/[̀-ͯ]/g, "");
  }
  if (!opts.keepPunctuation) {
    s = s.replace(PUNCTUATION, " ");
  }
  // Colapsa espacios.
  return s.replaceAll(/\s+/g, " ").trim();
}

/** Does `candidate` match any accepted (normalized) responses? */
export function matchesAny(
  candidate: string,
  accepted: readonly string[],
  opts: NormalizeOpts = {},
): boolean {
  const c = normalizeText(candidate, opts);
  if (c === "") {
    return false;
  }
  for (const a of accepted) {
    if (normalizeText(a, opts) === c) {
      return true;
    }
  }
  return false;
}
